<template>
  <transition :name="'fade'" mode="out-in">
    <CustomReveal
      v-if="register"
      :isVisible="register"
      revealId="card"
      class="register-modal"
      v-on:close-reveal-card="closeRegisterModal"
    >
      <div class="secondary-menu">
          <div class="secondary-menu-body register" id="card" data-reveal2>
            <div id="application-wrapper">
              <section class="onboarding">
                <div class="inner">
                  <div class="section-header" >
                    <i class="back" v-if="step !== 'welcome'" @click="goStepBack"></i>

                    <span class="title" v-if="step !== 'locality' && step !== 'welcome'">{{ trans('home.create_account') }}</span>
                    <div class="navigation" v-if="step !== 'welcome' && step !== 'locality'">
                      <div class="dot" :class="{'active': step === 1}"></div>
                      <div class="dot" :class="{'active': step === 2}"></div>
                      <div class="dot" :class="{'active': step === 3}"></div>
                      <div class="dot" :class="{'active': step === 4}"></div>
                      <div class="dot" :class="{'active': step === 5}"></div>
                    </div>
                  </div>

                  <div dusk="registration-form" class="section-body" :style="[step === 'welcome' || step === 'locality' ? {'padding-top': '0'} : '']">
                    <Step1 v-if="step === 1" v-bind:vars="$data"></Step1>
                    <Step2 v-else-if="step === 2" v-bind:vars="$data"></Step2>
                    <Step3 v-else-if="step === 3" v-bind:vars="$data"></Step3>
                    <Step4 v-else-if="step === 4" v-bind:vars="$data"></Step4>
                    <Step5 v-else-if="step === 5" v-bind:vars="$data"></Step5>
                    <Welcome v-else-if="step === 'welcome'"></Welcome>
                    <Location v-else-if="step === 'locality'" v-bind:vars="$data"></Location>
                  </div>
                </div>
              </section>
            </div>
          </div>
      </div>
    </CustomReveal>
  </transition>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import CustomReveal from '@buddy/views/widgets/CustomReveal.vue';
import Step1 from '@buddy/views/widgets/registration/Step1.vue';
import Step2 from '@buddy/views/widgets/registration/Step2.vue';
import Step3 from '@buddy/views/widgets/registration/Step3.vue';
import Step4 from '@buddy/views/widgets/registration/Step4.vue';
import Step5 from '@buddy/views/widgets/registration/Step5.vue';
import Welcome from '@buddy/views/widgets/registration/Welcome.vue';
import Location from '@buddy/views/widgets/registration/Location.vue'

export default {
  name: "RegisterModal",
  components: {
      Welcome,
      CustomReveal,
      Step1,
      Step2,
      Step3,
      Step4,
      Step5,
      Location,
  },
  mixins: [require('@general/lib/mixin').default],
  data() {
    return {
      step: 1,
      nickname: '',
      dob: this.registerDate(), //this needs moment globally for vee-validate to work
      email: '',
      handle: '',
      password: '',
      firstopen: true,
      avatarPhoto: null,
      nickNameStep: 1,
      handle_suggestions: [],
      handle_description: true,
      avatarPreview: null,
      avatarActions: {},
      acceptTerms: false,
      humanVerification: true,

      locationType: "",
      mapVisible: true,
      lat: 52.520389,
      lng: 13.40424,

      locality: 'Berlin',
      state: 'Berlin',
      country: 'Germany',
      skip_profile_picture: true,
      country_code: 'DE',
      location: '',
      location_type: 'error',
      address_type: 'full_address',
      address: '',
      addressShow: this.trans('reg.location_defining'),
      addressError: null,
      showpassword:true,
      buttonToTop : false,

      // Inner components variables
      honeypot: {
        hide: false,
        value: '',
      },
    }
  },
  computed: {
      ...mapState({
          register: state => state.modal.register
      })
  },
  methods: {
    goStepBack(fallback) {
      if (this.step === 1) {
        window.location.reload()
      } else if(this.step === 'locality') {
        this.step = 5;
      }else{
        if(this.step === 3 && this.nickNameStep === 2){
          this.nickNameStep = 1;
        }else{
          this.step--;
        }
      }
    }
  }
}
</script>